
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBillingItemSpecificationsGrid extends Serenity.EntityGrid<ProductBillingItemSpecificationsRow, any> {
        protected getColumnsKey() { return ProductBillingItemSpecificationsColumns.columnsKey; }
        protected getDialogType() { return ProductBillingItemSpecificationsDialog; }
        protected getIdProperty() { return ProductBillingItemSpecificationsRow.idProperty; }
        protected getInsertPermission() { return ProductBillingItemSpecificationsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductBillingItemSpecificationsRow.localTextPrefix; }
        protected getService() { return ProductBillingItemSpecificationsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {
            // debugger;
            this.editItem({ ProductId: this.ProductId });
            //  this.editItem({ ProductId: this.ProductId, IsTab: true });


        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.ProductId != null;
        }

        private _ProductId: number;

        get ProductId() {
            return this._ProductId;
        }

        set ProductId(value: number) {
            //debugger;
            if (this._ProductId != value) {
                this._ProductId = value;
                this.setEquality(ProductBillingItemSpecificationsRow.Fields.ProductId, value);
                this.refresh();
            }
        }
    }
}